/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '@swimlane/ngx-datatable/release/components/body/body-cell.component';
const styles_DataTableBodyCellComponent:any[] = ([] as any[]);
export const RenderType_DataTableBodyCellComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_DataTableBodyCellComponent,data:{}});
function View_DataTableBodyCellComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),3,'label',[['class',
      'datatable-checkbox']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n        '])),(_l()(),i0.ɵeld(2,
      0,(null as any),(null as any),0,'input',[['type','checkbox']],[[8,'checked',
          0]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.onCheckboxChange($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n      ']))],
      (null as any),(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.isSelected;
        _ck(_v,2,0,currVal_0);
      });
}
function View_DataTableBodyCellComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'span',([] as any[]),
      [[8,'title',0],[8,'innerHTML',1]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n      ']))],(null as any),
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.value;
        const currVal_1:any = _co.value;
        _ck(_v,0,0,currVal_0,currVal_1);
      });
}
function View_DataTableBodyCellComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n      ']))],(null as any),
      (null as any));
}
function View_DataTableBodyCellComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,[[1,3],['cellTemplate',2]],(null as any),
      2,(null as any),View_DataTableBodyCellComponent_4)),i0.ɵdid(1,540672,(null as any),
      0,i1.NgTemplateOutlet,[i0.ViewContainerRef],{ngTemplateOutlet:[0,'ngTemplateOutlet'],
          ngOutletContext:[1,'ngOutletContext']},(null as any)),i0.ɵpod(2,{value:0,
      row:1,column:2,isSelected:3,onCheckboxChangeFn:4,activateFn:5}),(_l()(),i0.ɵand(0,
      (null as any),(null as any),0))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.column.cellTemplate;
    const currVal_1:any = _ck(_v,2,0,_co.value,_co.row,_co.column,_co.isSelected,_co.onCheckboxChangeFn,
        _co.activateFn);
    _ck(_v,1,0,currVal_0,currVal_1);
  },(null as any));
}
export function View_DataTableBodyCellComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(671088640,1,{cellTemplate:0}),(_l()(),i0.ɵted(-1,(null as any),
      ['\n    '])),(_l()(),i0.ɵeld(2,0,(null as any),(null as any),10,'div',[['class',
      'datatable-body-cell-label']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n      '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_DataTableBodyCellComponent_1)),
      i0.ɵdid(5,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DataTableBodyCellComponent_2)),
      i0.ɵdid(8,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DataTableBodyCellComponent_3)),
      i0.ɵdid(11,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i0.ɵted(-1,(null as any),['\n  ']))],(_ck,_v) => {
    var _co:i2.DataTableBodyCellComponent = _v.component;
    const currVal_0:any = _co.column.checkboxable;
    _ck(_v,5,0,currVal_0);
    const currVal_1:boolean = !_co.column.cellTemplate;
    _ck(_v,8,0,currVal_1);
    const currVal_2:any = _co.column.cellTemplate;
    _ck(_v,11,0,currVal_2);
  },(null as any));
}
export function View_DataTableBodyCellComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'datatable-body-cell',
      [['class','datatable-body-cell']],[[8,'className',0],[4,'width','px'],[4,'height',
          (null as any)]],[[(null as any),'focus'],[(null as any),'blur'],[(null as any),
          'click'],[(null as any),'dblclick'],[(null as any),'keydown']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('focus' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onFocus()) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,1).onBlur()) !== false);
          ad = (pd_1 && ad);
        }
        if (('click' === en)) {
          const pd_2:any = ((<any>i0.ɵnov(_v,1).onClick($event)) !== false);
          ad = (pd_2 && ad);
        }
        if (('dblclick' === en)) {
          const pd_3:any = ((<any>i0.ɵnov(_v,1).onDblClick($event)) !== false);
          ad = (pd_3 && ad);
        }
        if (('keydown' === en)) {
          const pd_4:any = ((<any>i0.ɵnov(_v,1).onKeyDown($event)) !== false);
          ad = (pd_4 && ad);
        }
        return ad;
      },View_DataTableBodyCellComponent_0,RenderType_DataTableBodyCellComponent)),
      i0.ɵdid(1,180224,(null as any),0,i2.DataTableBodyCellComponent,[i0.ElementRef],
          (null as any),(null as any))],(null as any),(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).columnCssClasses;
    const currVal_1:any = i0.ɵnov(_v,1).width;
    const currVal_2:any = i0.ɵnov(_v,1).height;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
export const DataTableBodyCellComponentNgFactory:i0.ComponentFactory<i2.DataTableBodyCellComponent> = i0.ɵccf('datatable-body-cell',
    i2.DataTableBodyCellComponent,View_DataTableBodyCellComponent_Host_0,{row:'row',
        column:'column',rowHeight:'rowHeight',isSelected:'isSelected',sorts:'sorts'},
    {activate:'activate'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/src/$$_gendir/node_modules/@swimlane/ngx-datatable/release/components/body/body-cell.component.ngfactory.ts